import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import SonnensucheApp from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SonnensucheApp />
  </React.StrictMode>
);
